import React from "react";
import { useState } from "react";
import Tabs from "../../../../components/Tabs";
import Escenarios from "../escenarios";
import GraficoRescates from "../graficoRescates";
import TerminosCondiciones from "../terminos-condiciones";
import * as Constantes from "../../../../utils/constantes";

const ProyeccionVida = ({ producto, textosLegales }) => {
    const itemsTab = [
        {
            id: 1,
            descripcion: 'Tabla de Proyecciones',
            componente: <Escenarios escenarios={producto.escenarios} moneda={producto.moneda} />
        },
        {
            id: 2,
            descripcion: 'Gráfico de Rescates',
            componente: <GraficoRescates producto={producto} />
        }
    ]

    const textosLegalesFilter = textosLegales !== null
        ? textosLegales.filter(textoLegal => textoLegal.codigoProducto === producto.codigoProducto).map((textoLegal) => {
            return {
                id: textoLegal.codigoTxtLegal,
                descripcion: textoLegal.detalleTxtLegal
            }
        }) : undefined

    const [ tabSelect, setTabSelect ] = useState(1)

    return (
        <React.Fragment>
            <Tabs
                itemsTab={itemsTab}
                tabSelect={tabSelect}
                setTabSelect={setTabSelect}
            />
            <TerminosCondiciones
                fondos={Constantes.FONDOS}
                terminosCondiciones={textosLegalesFilter}
            />
        </React.Fragment>
    )
}

export default ProyeccionVida;